export default __webpack_public_path__ + "static/media/a_wdt_c_2.1cdc38f3.mp3";